import Axios, { type AxiosResponse } from "axios";
import { ENV_CONFIG } from "common/config/env.config";

const axiosInstance = Axios.create({
  baseURL: `${ENV_CONFIG.API_URL}`,
  timeout: 300000
});

axiosInstance.interceptors.response.use((response: AxiosResponse) => {
  return response;
});

// TODO : Remove any here
axiosInstance.interceptors.request.use((request: any) => {
  return request;
});

export default axiosInstance;
